'use client';

import React from 'react';

import {
  LOYALFANS_URL,
  THRONE_URL,
  I_WANT_CLIPS_URL,
  MANY_VIDS_URL,
  CLIPS4SALE_URL,
  CASH_APP_URL,
} from '../../utils/constants/Constants';

import { SiCashapp } from 'react-icons/si';
import { FaVideo } from 'react-icons/fa';

// image icons
import ThroneIconPurple from '../../assets/images/icons/white/throne-icon-no-background.png';
import LoyalFansIcon from '../../assets/images/icons/white/loyalfans-icon-no-background.png';
import ManyVidsIcon from '../../assets/images/icons/white/manyvids-white.png';
import C4SIcon from '../../assets/images/icons/white/clips4sale-logo.png';

const importantLinks = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    icon: (
      <img
        src={LoyalFansIcon}
        alt='LoyalFans'
        className='w-8 h-8 object-contain'
      />
    ),
  },
  {
    name: 'Clips4Sale',
    url: CLIPS4SALE_URL,
    icon: (
      <img src={C4SIcon} alt='Clips4Sale' className='w-8 h-8 object-contain' />
    ),
  },
  {
    name: 'IWantClips',
    url: I_WANT_CLIPS_URL,
    icon: <FaVideo className='text-2xl' />,
  },
  {
    name: 'ManyVids',
    url: MANY_VIDS_URL,
    icon: (
      <img
        src={ManyVidsIcon}
        alt='ManyVids'
        className='w-8 h-8 object-contain'
      />
    ),
  },
  {
    name: 'Throne',
    url: THRONE_URL,
    icon: (
      <img
        src={ThroneIconPurple}
        alt='Throne Wishlist'
        className='w-8 h-8 object-contain'
      />
    ),
  },
  {
    name: 'CashApp',
    url: CASH_APP_URL,
    icon: <SiCashapp className='text-2xl' />,
  },
];

export default function HomeImportantLinksCTA() {
  return (
    <section className='grid gap-6 pt-2' aria-label='Important links'>
      <div className='grid grid-cols-6 xxs:gap-2 sm:gap-4 place-items-center md:w-fit md:mx-auto'>
        {importantLinks.map((item) => (
          <a
            key={item.name}
            href={item.url}
            target='_blank'
            rel='noreferrer'
            aria-label={`Open ${item.name}`}
            className='grid grid-rows-rev h-full place-items-center gap-2 text-center hover:opacity-80 transition-opacity'
          >
            <div className='grid h-full place-items-center'>{item.icon}</div>

            <div className='h-fit'>
              <span className='xxs:text-[8px] xs:text-[9px] font-medium'>{item.name}</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
